import { render, staticRenderFns } from "./biddingRemarkForm.vue?vue&type=template&id=2d300af9&scoped=true&"
import script from "./biddingRemarkForm.vue?vue&type=script&lang=js&"
export * from "./biddingRemarkForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d300af9",
  null
  
)

export default component.exports